export default class Option {
  constructor(text, value, data = {}) {
    this.text = text;
    this.value = value;
    this.data = data;

    const ignoreDataKeys = ['group', 'desc', 'avatar', 'icon', 'search-key'];
    this.dataAttributes = Object.keys(data).reduce((result, dataKey) => {
      if (ignoreDataKeys.indexOf(dataKey) === -1) {
        Object.assign(result, { [dataKey]: data[dataKey] });
      }
      return result;
    }, {});
  }

  match(value) {
    const filterKey = this.data['search-key'] || this.text;
    return String(filterKey).toLowerCase().indexOf(value.toLowerCase()) > -1;
  }

  static fromElement(element, includeDisabled = false) {
    const { value, disabled } = element;
    if (!value || (!includeDisabled && disabled)) return null;

    const data = {};
    Array.from(element.attributes).forEach((attr) => {
      if (attr.name.startsWith('data-')) {
        data[attr.name.replace(/^data-/, '')] = attr.value;
      }
    });

    const { parentNode } = element;
    if (parentNode && parentNode.tagName.toLowerCase() === 'optgroup') {
      data.group = parentNode.getAttribute('label');
    }

    if (includeDisabled && disabled) data.disabled = true;

    return new Option(element.text, value, data);
  }

  static fromJSON(json, group) {
    const data = json.length > 2 ? json[2] : {};

    Object.keys(data).forEach((dataKey) => {
      const dataValue = data[dataKey];
      if (dataKey.startsWith('data-')) {
        data[dataKey.replace(/^data-/, '')] = dataValue;
        delete data[dataKey];
      }
    });

    if (group) data.group = group;

    return new Option(json[0], json[1], data);
  }
}
